import React from "react";
import { GalleryItem } from "./";
import { useSelector } from "react-redux";
import { selectAppraisal } from "../../../store/selectors";

export default function GalleryItemContainer({ image }) {
  const { fileStack } = useSelector(selectAppraisal);
  const readyToRender = Boolean(fileStack.keys.policy);

  return (
    readyToRender && <GalleryItem image={image} key={image.imageIdentifier} />
  );
}
